<template>
  <div class="main">
    <div class="banner">
      <img src="https://www.bjecpower.com/img/gw/pb00.png" alt="" />
    </div>
    <div class="banner_mo">
      <img src="https://www.bjecpower.com/img/gw/mb00.png" alt="" />
    </div>
    <Company ref="scroll_Company" />
    <Solution />
    <About />
    <!-- <Progra /> -->
    <Swiper ref="scroll_Swiper" />
    <div class="heightnor"></div>
    <Honor ref="scroll_Honor" />
    <div class="home_pos" v-if="top">
      <div class="father">
        <img class="son" src="../assets/pc/er.png" alt="" />
      </div>
      <div @mouseover="gohover" v-if="!goFlag">
        <img src="../assets/pc/goa.png" class="goimg" alt="" />
      </div>
      <div @click="backtop" @mouseout="goOut" v-else>
        <img src="../assets/pc/gob.png" class="goimg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import Company from "@/components/company";
import About from "@/components/about";
import Progra from "@/components/progra";
import Swiper from "@/components/swiper";
import Honor from "@/components/honor";
import Solution from "@/components/solution";
export default {
  components: {
    Company,
    About,
    Progra,
    Swiper,
    Honor,
    Solution,
  },
  data() {
    return {
      goFlag: false,
      top: false,
    };
  },
  mounted() {
    this.$bus.$on("scrollGo", (data) => {
      let arr = ["公司简介", "合作伙伴", "资质与荣誉", "联系我们"];
      let scrollArr = [
        "scroll_Company",
        "scroll_Swiper",
        "scroll_Honor",
        "scroll_Honor",
      ];
      arr.map((item, index) => {
        if (data.name === item) {
          window.scrollTo(
            100,
            this.$refs[scrollArr[index]].$el.offsetTop ||
              document.body.scrollHeight
          );
          return;
        }
      });
      // if()
      // scrollHeight
    });
    // window.addEventListener("scroll", this.showbtn, true);
    var THIS = this;
    window.addEventListener("scroll", function () {
      //监听滚动
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;

      if (scrollTop >= 500) {
        //如果当前滚动位置大于您的所需要达到的高度则显示置顶元素，反之不显示
        THIS.top = true;
      } else {
        THIS.top = false;
      }
    });
  },
  methods: {
    gohover() {
      this.goFlag = true;
    },
    goOut() {
      this.goFlag = false;
    },
    gohover() {
      this.goFlag = true;
    },

    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
  },
};
</script>


<style scoped>
.banner_mo {
  display: none;
}
 .heightnor{
    height:30px;background:#fff;
  }
.banner {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
}

.banner img {
  max-width: 100%;
  width: 100%;
}

@media screen and (max-width: 768px) {
  .heightnor{ display: none; }
 
  .banner {
    display: none;
  }
  .banner_mo {
    display: block;
    width: 100%;
    
  }

  .banner_mo img {
    max-width: 100%;
    width: 100%;
  }
}
.home_pos {
  position: fixed;
  right: 16px;
  bottom: 6%;
  width: 100px;
}

.home_pos .goimg {
  width: 115px;
  height: 115px;
  cursor: pointer;
}

.father {
  width: 115px;
  height: 115px;
  background-image: url("https://www.bjecpower.com/camera/company/wea.png");
  background-size: 100% 100%;
  cursor: pointer;
  position: relative;
}

.son {
  height: 0px;
  width: 0px;
  position: absolute;
  top: 0;
  right: 85%;
  /* 收回的时候快一点 */
  transition: width 200ms;
}

/* 交集选择器，所以父子关系的div盒子才可以 */
.father:hover .son {
  /* 将transition写在;hover中，很是巧妙 */
  /* 伸展的时候慢一点 */
  width: 190px;
  height: 214px;
  transition: width 800ms;
}

.btn {
  font-size: 20px;
  padding: 12px 30px;
  margin-top: 200px;
}
@media screen and (max-width: 768px) {
  
  .home_pos {
    display: none;
  }
  .banner {
    width: 100%;
    height: 430px;
    background-image: url("https://www.bjecpower.com/camera/company/mobanner.jpg");
    background-size: 100% 100%;
    z-index: 1000;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/homeindex.vue